import React, { Component } from "react";
import _ from "lodash";
import { withRouter } from "react-router";

import { MakeSearchUrl } from "../../utils/consts";

import Dropdown, {
  DropdownItemGroup,
  DropdownItem
} from "@atlaskit/dropdown-menu";
import Button from "@atlaskit/button";
import FieldText from "@atlaskit/field-text";

// import InputRange from "react-input-range";
// import { Range } from "rc-slider";

import "rc-slider/assets/index.css";
import "mapbox-gl/dist/mapbox-gl.css";
import "react-input-range/lib/css/index.css";

import "./search.css";

// import Slider from "rc-slider";
// const createSliderWithTooltip = Slider.createSliderWithTooltip;
// const Range = createSliderWithTooltip(Slider.Range);

class Search extends Component {
  handleFilter = (i, item, newSelection) => {
    this.props.handleFilter(i, item, newSelection);
    this.props.history.push({
      search: ""
    });
  };

  search = value => {
    const url = MakeSearchUrl(value);
    this.props.history.push({
      search: `${url}`
    });
    this.props.search();
  };

  render() {
    const value = this.props.value || {};
    return (
      <div className="search-params">
        <div className="price-select search-select">
          <Dropdown
            shouldFlip={true}
            position="bottom left"
            trigger={
              <Button
                className={`search-select__btn ${
                  !!value.minexpense || !!value.maxexpense
                    ? "search-select__btn_selected"
                    : ""
                }`}
                isSelected={!!value.minexpense || !!value.maxexpense}
              >
                {!!value.minexpense || !!value.maxexpense
                  ? `$${value.minexpense} - $${value.maxexpense}`
                  : "Rent..."}
              </Button>
            }
          >
            <div className="price-select__range-container">
              <FieldText
                label="Min Expense"
                type="number"
                compact
                isInvalid={isNaN(value.minexpense)}
                onChange={e =>
                  this.handleFilter(parseInt(e.target.value, 10), "minexpense")
                }
                className="price-select__field-input"
                value={value.minexpense}
              />
              <FieldText
                label="Max expense"
                type="number"
                compact
                isInvalid={isNaN(value.maxexpense)}
                onChange={e =>
                  this.handleFilter(parseInt(e.target.value, 10), "maxexpense")
                }
                className="price-select__field-input"
                value={value.maxexpense}
              />
            </div>
          </Dropdown>
        </div>
        <div className="beds-select search-select">
          <Dropdown
            shouldFlip={true}
            position="bottom left"
            trigger={
              <Button
                className={`search-select__btn ${
                  !!value.beds || value.beds === 0
                    ? "search-select__btn_selected"
                    : ""
                }`}
                isSelected={!!value.beds || value.beds === 0}
              >
                {!!value.beds || value.beds === 0
                  ? `${value.beds} bed${value.beds !== 1 ? "s" : ""}`
                  : "Beds..."}
              </Button>
            }
          >
            <DropdownItemGroup>
              {_.times(5, i => i).map(i => (
                <DropdownItem
                  key={`beds-select__btn-${i}`}
                  isSelected={value.beds === i}
                  onClick={() => this.handleFilter(i, "beds", value.beds === i)}
                  className={
                    value.beds === i
                      ? "dropdown-select__btn dropdown-select__btn_selected"
                      : "dropdown-select__btn"
                  }
                >
                  {`${i} beds`}
                </DropdownItem>
              ))}
            </DropdownItemGroup>
          </Dropdown>
        </div>
        <div className="baths-select search-select">
          <Dropdown
            shouldFlip={true}
            position="bottom left"
            trigger={
              <Button
                className={`search-select__btn ${
                  !!value.baths || value.baths === 0
                    ? "search-select__btn_selected"
                    : ""
                }`}
                isSelected={!!value.baths || value.baths === 0}
              >
                {!!value.baths || value.baths === 0
                  ? `${value.baths} bath${value.baths !== 1 ? "s" : ""}`
                  : "Baths..."}
              </Button>
            }
          >
            <DropdownItemGroup>
              {_.times(5, i => i).map(i => (
                <DropdownItem
                  key={`baths-select__btn-${i}`}
                  isSelected={value.baths === i}
                  onClick={() =>
                    this.handleFilter(i, "baths", value.baths === i)
                  }
                  className={
                    value.baths === i
                      ? "dropdown-select__btn dropdown-select__btn_selected"
                      : "dropdown-select__btn"
                  }
                >
                  {`${i} baths`}
                </DropdownItem>
              ))}
            </DropdownItemGroup>
          </Dropdown>
        </div>
        <div className="parking-select search-select">
          <Dropdown
            shouldFlip={true}
            position="bottom left"
            trigger={
              <Button
                className={`search-select__btn ${
                  !!value.parking || value.parking === 0
                    ? "search-select__btn_selected"
                    : ""
                }`}
                isSelected={!!value.parking || value.parking === 0}
              >
                {!!value.parking || value.parking === 0
                  ? `${value.parking} parking`
                  : "Parking..."}
              </Button>
            }
          >
            <DropdownItemGroup>
              {_.times(3, i => i).map(i => (
                <DropdownItem
                  key={`parking-select__btn-${i}`}
                  isSelected={value.parking === i}
                  onClick={() =>
                    this.handleFilter(i, "parking", value.parking === i)
                  }
                  className={
                    value.parking === i
                      ? "dropdown-select__btn dropdown-select__btn_selected"
                      : "dropdown-select__btn"
                  }
                >
                  {`${i} parking`}
                </DropdownItem>
              ))}
            </DropdownItemGroup>
          </Dropdown>
        </div>
        <div className="furnished-select search-select">
          <Button
            key={`furnished-select__btn`}
            onClick={() => this.handleFilter(!value.furnished, "furnished")}
            isSelected={!!value.furnished}
            className={`search-select__btn ${
              !!value.furnished ? "search-select__btn_selected" : ""
            }`}
          >
            {value.furnished ? `furnished` : `unfurnished`}
          </Button>
        </div>
        {this.props.link ? (
          <a className="search-btn__link" href={`${this.props.link}`}>
            <Button
              onClick={this.props.search}
              className="search-btn search-select search-select__btn"
            >
              search
            </Button>
          </a>
        ) : (
          <Button
            className="search-btn search-select search-select__btn"
            isLoading={this.props.searching}
            onClick={() => this.search(value)}
          >
            search
          </Button>
        )}
      </div>
    );
  }
}

export default withRouter(Search);

// {
// <FieldText
//   label="Min Expense"
//   type="number"
//   compact
//   isInvalid={isNaN(value.minexpense)}
//   onChange={e => this.handleFilter(e.target.value, "minexpense")}
//   value={value.minexpense}
// />
//   <FieldText
//     label="Max expense"
//     type="number"
//     compact
//     isInvalid={isNaN(value.maxexpense)}
//     onChange={e => this.handleFilter(e.target.value, "maxexpense")}
//     value={value.maxexpense}
//   />}

// {
//   <DropdownItemGroup>
//     <DropdownItem
//       key={`price-select__btn`}
//       className="price-select__btn"
//     >
//       <Range
//         tipFormatter={value => `$${value}`}
//         step={100}
//         min={1500}
//         max={5000}
//         value={[value.minexpense, value.maxexpense]}
//         onChange={v => {
//           this.handleFilter(v[0], "minexpense");
//           this.handleFilter(v[1], "maxexpense");
//         }}
//       />
//     </DropdownItem>
//   </DropdownItemGroup>
// }

// {<InputRange
//   className={`search-select__btn ${
//     !!value.minexpense ||
//       value.minexpense === 0 ||
//       !!value.maxexpense ||
//       value.maxexpense === 0
//       ? "search-select__btn_selected"
//       : ""
//     }`}
//   step={100}
//   minValue={1000}
//   maxValue={7000}
//   value={{
//     min: value.minexpense,
//     max: value.maxexpense
//   }}
//   onChange={v => {
//     this.handleFilter(v.min, "minexpense");
//     this.handleFilter(v.max, "maxexpense");
//   }}
// />}



// WEBPACK FOOTER //
// ./src/components/SearchMap/Search.js